import React from "react";
import { bookData } from "../data/mock";
import { Badge } from "./ui/badge";
import { Separator } from "./ui/separator";
import { BookOpen, ArrowRight } from "lucide-react";

const BookSection = () => {
  return (
    <section id="book" className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal-600/30 to-transparent" />
        <div className="absolute top-1/3 right-0 w-80 h-80 bg-amber-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/3 left-0 w-80 h-80 bg-teal-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 backdrop-blur-md rounded-2xl py-10">
        {/* Section header */}
        <div className="flex items-center gap-3 mb-16">
          <BookOpen className="w-5 h-5 text-teal-400" />
          <span className="font-nunito text-teal-400 text-sm tracking-[0.25em] uppercase font-semibold">
            Publicación
          </span>
          <div className="flex-1 h-px bg-teal-500/20" />
        </div>

        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Book cover - smaller column */}
          <div className="lg:col-span-2 relative group flex justify-center">
            <div className="relative">
              <div className="relative overflow-hidden rounded-lg shadow-2xl shadow-black/40 max-w-[340px] mx-auto">
                <img
                  src={bookData.image}
                  alt={bookData.title}
                  className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-[1.02]"
                />
              </div>
              {/* Book shadow effect */}
              <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-[80%] h-8 bg-black/30 blur-xl rounded-full" />
            </div>
          </div>

          {/* Book content */}
          <div className="lg:col-span-3 rounded-2xl p-6">
            <Badge variant="outline" className="border-amber-600/50 text-amber-700 font-nunito text-xs px-3 py-1 mb-4">
              Dramaturgia - 2024
            </Badge>

            <h2 className="font-bebas text-5xl md:text-6xl text-black lg:text-teal-400 tracking-wide mb-2">
              Soledad <span className="text-teal-400">F451</span>
            </h2>
            <p className="font-nunito text-sm text-slate-400 mb-6 italic">{bookData.subtitle}</p>

            <p className="font-nunito text-lg text-slate-200 leading-relaxed mb-4">{bookData.description}</p>
            <p className="font-nunito text-base text-slate-200 leading-relaxed mb-8">{bookData.extendedDescription}</p>

            <Separator className="bg-teal-500/15 mb-8" />

            {/* Details grid */}
            <div className="space-y-4">
              {bookData.details.map((detail, idx) => (
                <div
                  key={idx}
                  className="group/item flex items-start gap-3 p-3 rounded-lg hover:bg-white/10 transition-colors duration-300 -mx-3"
                >
                  <ArrowRight className="w-4 h-4 text-teal-400 mt-1 shrink-0 group-hover/item:translate-x-0.5 transition-transform duration-300" />
                  <div>
                    <span className="font-nunito text-xs text-teal-400 uppercase tracking-wider font-semibold">
                      {detail.label}
                    </span>
                    <p className="font-nunito text-sm text-slate-200 mt-0.5">{detail.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookSection;
